import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {PhotoDetailsComponent} from './photo-details/photo-details.component';
import {SuccessPageComponent} from '../../shared/components/success-page/success-page.component';
import {SuccessGuardService} from '../../shared/services/guard-services/success-guard.service';
import {PhotoEditComponent} from './photo-edit/edit.component';
import {PhotoReviewComponent} from './photo-review/photo-review.component';
import {CamerallaAuthGuardService} from '../../shared/services/guard-services/cameralla-auth-guard.service';

const routes: Routes = [
    {
        path: ':id',
        component: PhotoDetailsComponent,
    },
    {
        path: 'review/:id',
        component: PhotoReviewComponent,
    },
    {
        path: ':id/edit',
        component: PhotoEditComponent,
    },
    {
        path: ':id/:action',
        component: SuccessPageComponent,
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: [SuccessGuardService]
})
export class PhotoRoutingModule {
}

